import { LucideInfo } from 'lucide-react'
import React from 'react'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '~/components/ui'

export default function InfoTooltip({
  children,
  side = 'left',
  align = 'center',
}: {
  className?: string
  children: React.ReactNode
  side?: 'left' | 'right' | 'top' | 'bottom'
  align?: 'start' | 'center' | 'end'
}) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <button className="inline-flex items-center gap-4 rounded-md px-1 py-1 text-left">
            <LucideInfo className="h-4 w-4" />
          </button>
        </TooltipTrigger>
        <TooltipContent side={side} align={align}>
          <div className="max-w-sm">{children}</div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
